  export default[
      {
        path: "/YHREYSGNKGJFSGHFURUTYRTURETIUIHHSUG",
        children: [
          {
            path: "UFWNIUFGTIUVRTEFEWFRFRE8TUREYEOIDYMENE",
            name: "saiqe25.grades",
            component: () => import("@/views/saiqe/twf/grades/list.vue"),
            meta: {
              title: "SAIQE grade(s)",
              authRequired: true,
              acc: ["y27461"],
            },
          },
          {
            path: "NYHJOFUDIUFYHGECVEGNREYUGHTHENTUUT",
            name: "saiqe25.upload.grades",
            component: () => import("@/views/saiqe/twf/grades/upload.vue"),
            meta: {
              title: "Upload SAIQE Grade(s)",
              authRequired: true,
              acc: ["y31711"],
            },
          },
        //   {
        //     path: "GVNHERREOWHWI5UT0TEYRHRNUNRYTJ3O5UTUYTER",
        //     name: "saiqe25.update.grades.25",
        //     component: () => import("../views/saiqe/grades/update.vue"),
        //     meta: {
        //       title: "Update SAIQE Grade(s)",
        //       authRequired: true,
        //       acc: ["y41288"],
        //     },
        //   },
          {
            path: "JEBHVRWTHERITITYRTWYWE£DEFE3T8UNYGYTefiGUKGYVFYSDF",
            name: "saiqe25.export.grades",
            component: () => import("@/views/saiqe/twf/grades/export.vue"),
            meta: {
              title: "Export SAIQE Grade(s)",
              authRequired: true,
              acc: ["y41288"],
            },
          },
        ],
      },
  ]